<fa-icon [icon]="faIcon"></fa-icon>